import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import AppContainer from './components/AppContainer';

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById('root'),
);
